import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderStatus',
})
export class OrderStatusPipe implements PipeTransform {
  transform(value: number, type: string): string {
    const purchaseOrderStatus = [
      'Draft',
      'Published',
      'Sent to Vendor',
      'Partially Received',
      'Fully Received',
      'Cancelled',
    ];
    const saleOrderStatus = [
      'Draft',
      'Created',
      'Confirmed',
      'Ready for Dispatch',
      'Dispatched',
      'Delivered',
      'Cancelled',
    ];
    if (type === 'po') {
      if (value <= purchaseOrderStatus.length) {
        return purchaseOrderStatus[value];
      } else {
        return 'Invalid status';
      }
    } else if (type === 'so') {
      if (value <= saleOrderStatus.length) {
        return saleOrderStatus[value];
      } else {
        return 'Invalid status';
      }
    } else {
      return 'Order type not found';
    }
  }
}
